<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
		<g clip-path="url(#clip0_2014_16572)">
			<path
				d="M10.3485 15.9829C7.60566 15.9829 5.36566 13.7429 5.36566 11C5.36566 8.25715 7.60566 6.01715 10.3485 6.01715C13.0914 6.01715 15.3314 8.25715 15.3314 11C15.3314 13.7429 13.0914 15.9829 10.3485 15.9829ZM10.3485 7.29714C8.3028 7.29714 6.64566 8.95429 6.64566 11C6.64566 13.0457 8.3028 14.7029 10.3485 14.7029C12.3943 14.7029 14.0514 13.0457 14.0514 11C14.0514 8.95429 12.3943 7.29714 10.3485 7.29714Z"
				fill="#646E87"
			/>
			<path
				d="M14.0057 3.86858V3.33144C14.0057 1.49144 12.5086 -0.00570679 10.6685 -0.00570679H4.00566C2.16566 -0.00570679 0.668518 1.49144 0.668518 3.33144V12.6686C0.668518 14.5086 2.16566 16.0057 4.00566 16.0057H6.21137C6.57709 16.0057 6.87423 15.7086 6.87423 15.3429C6.87423 14.9772 6.57709 14.68 6.21137 14.68H4.00566C2.90852 14.68 2.00566 13.7772 2.00566 12.68V4.68001H12.6686V5.78858C12.6686 6.1543 12.9657 6.45144 13.3314 6.45144C13.6971 6.45144 13.9943 6.1543 13.9943 5.78858V3.88001L14.0057 3.86858ZM2.00566 3.33144C2.00566 2.2343 2.90852 1.33144 4.00566 1.33144H10.6685C11.7657 1.33144 12.6686 2.2343 12.6686 3.33144H2.00566Z"
				fill="#646E87"
			/>
			<path
				d="M11.9028 11.5943L11.0228 11V9.41142C11.0228 9.04571 10.7257 8.74857 10.3599 8.74857C9.99423 8.74857 9.69708 9.04571 9.69708 9.41142V11.32C9.69708 11.32 9.69708 11.3657 9.70851 11.3771C9.70851 11.5829 9.81137 11.7886 9.99423 11.9143L11.1714 12.7029C11.48 12.9086 11.8914 12.8286 12.0971 12.52C12.3028 12.2114 12.2228 11.8 11.9143 11.5943H11.9028Z"
				fill="#646E87"
			/>
		</g>
		<defs>
			<clipPath id="clip0_2014_16572">
				<rect width="16" height="16" fill="white" />
			</clipPath>
		</defs>
	</svg>
</template>

<script>
export default {
	name: 'TaskLogSVG',
};
</script>
